import React from "react";

export default function Skeleton() {
	return (
		<div aria-hidden="true">
			<span className="skeleton-shimmer block h-4 mb-2 bg-gray-200 w-1/2"></span>
			<span className="skeleton-shimmer block h-10 mb-2 bg-gray-400 w-10/12"></span>
			<span className="skeleton-shimmer block h-8 mb-2 bg-gray-400 w-3/4"></span>
			<span className="skeleton-shimmer block h-8 mb-12 bg-gray-400 w-7/12"></span>
		</div>
	);
}
